import clsx from 'clsx';
import { getVarName, rems } from '../utils/css.js';
import { size, smallAvatarGroupGap } from '../styles/avatar-base.css.js';
import { initialFontSize, avatarSize } from '../styles/avatar-base.vars.css.js';

// Named-variant pixel dimensions, kept in sync with the `size` styleVariants in avatar-base.css.ts.
const BUCKET_PX = { sm: 16, md: 24, lg: 32, xlg: 48 };
/**
 * Resolves a `size` prop into the class / inline-style / typography choices shared by
 * Avatar and AvatarButton. A numeric size still applies its `nearestBucket` size class and
 * overrides only `avatarSize` inline, so width/height, the `avatarSize` the AvatarGroup reads and
 * its crescent geometry all follow the exact pixel value, while the square radius and initials
 * typography stay on the bucket's tokens.
 */
function resolveAvatarSize(size$1) {
    if (typeof size$1 === 'number') {
        const bucket = nearestAvatarSizeBucket(size$1);
        return {
            sizeClassName: clsx(size[bucket], size$1 < BUCKET_PX.sm && smallAvatarGroupGap),
            sizeStyle: {
                [getVarName(avatarSize)]: rems(size$1),
                [getVarName(initialFontSize)]: rems(Math.round((size$1 * 5) / 8)),
            },
            typographySize: bucket,
        };
    }
    return { sizeClassName: size[size$1], sizeStyle: undefined, typographySize: size$1 };
}
/**
 * Nearest named size for an arbitrary pixel value, by midpoint. Ties round up (20 → md, 40 → xlg).
 * The container renders at the exact pixel size regardless; this only picks which initials
 * typography composable and square-corner radius token to reuse.
 */
function nearestAvatarSizeBucket(px) {
    if (px < (BUCKET_PX.sm + BUCKET_PX.md) / 2)
        return 'sm';
    if (px < (BUCKET_PX.md + BUCKET_PX.lg) / 2)
        return 'md';
    if (px < (BUCKET_PX.lg + BUCKET_PX.xlg) / 2)
        return 'lg';
    return 'xlg';
}

export { nearestAvatarSizeBucket, resolveAvatarSize };
//# sourceMappingURL=avatar.utils.js.map
